import { render } from "./NewsDetailFeb2024Page.vue?vue&type=template&id=2e6260b1"
import script from "./NewsDetailFeb2024Page.vue?vue&type=script&lang=js"
export * from "./NewsDetailFeb2024Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__